// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone-component_1eb735c5 {
  border: 0.167rem dashed #dce1e5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 2.667rem;
  cursor: pointer;
  background: #f8f9fa;
  border-radius: 0.333em;
  overflow: hidden;
}
.dropzone-component_active_1eb735c5 {
  border: 0.084rem solid #6185a6;
  box-shadow: 0 0 0 0.167rem #dceffa;
}
.dropzone-component_reject_1eb735c5 {
  borderColor: '#db663c';
  backgroundColor: '#f7e2db';
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropzone-component": `dropzone-component_1eb735c5`,
	"dropzone-component_active": `dropzone-component_active_1eb735c5`,
	"dropzone-component_reject": `dropzone-component_reject_1eb735c5`
};
export default ___CSS_LOADER_EXPORT___;
